/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_PRESENTATION } from "../graphql/getPresentation.query";
import { GET_BOXES } from "../graphql/getBoxes.query";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { GET_OPEN_PRESENTATION } from "../graphql/getOpenPresentation.query";
import { GET_BANDS } from "../../costumePageService/graphql/getBands.query";
import { emailMap } from "../../../helpers/marketing.email";

const is = require("is_js");
const isVideo: any = /\.(mp4|mov|avi|avchd|flv|f4v|swf|mkv|webm|html5)$/i;
const isYoutubeVideo: any =
  /^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/i;

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetPresentationMethods extends IPluginMethodMap {
  getPresentation(args: any): Promise<any>;
}

export class GetPresentationService implements IAgentPlugin {
  readonly methods: IGetPresentationMethods;

  constructor() {
    this.methods = {
      getPresentation: this.getPresentation.bind(this),
    };
  }

  async getPresentation(args: any) {
    const graphqlModule = getGraphQLModule();
    const storageSrv = StorageModule.getInstance();
    const loginSession = storageSrv?.get("userProfile", "session");
    const localSession = storageSrv?.get("userProfile", "local");
    const band = storageSrv?.get("theme", "local");

    const _token = loginSession ?? localSession;
    const client = graphqlModule.getClient("graphql-gateway");
    let presentationArray: any = [];
    let _band;
    if (is.existy(localStorage?.band)) {
      _band = localStorage?.band;
    }
    try {
      console.log("accesstoooken", _token);
      console.log("accesstoooken", args);
      if (client) {
        // if (_token?.accessToken) {
        //   const res1 = await client.query({
        //     query: GET_BANDS,
        //     variables: {
        //       filter: {
        //         bandName: _band,
        //       },
        //     },
        //     fetchPolicy: "network-only",
        //   });
        //   let data: any[] = [];

        //   const boxRes = await client.query({
        //     query: GET_BOXES,
        //     variables: {},
        //     fetchPolicy: "network-only",
        //   });

        //   if (
        //     boxRes?.data?.getMyBoxes?.content &&
        //     boxRes?.data?.getMyBoxes?.content.length > 0
        //   ) {
        //     data = boxRes?.data?.getMyBoxes?.content;

        //     for (let obj of data) {
        //       if (
        //         obj?.presentation?.name &&
        //         is.existy(obj?.presentation?.name)
        //       ) {
        //         if (!presentationArray.includes(obj?.presentation?.name)) {
        //           presentationArray.push(obj?.presentation?.name);
        //         }
        //       }
        //     }
        //   }
        //   if (
        //     res1?.data?.getBand?.isMultiplePurchase === false &&
        //     Array.isArray(data) &&
        //     data.length > 0
        //   ) {
        //     const hasActive = data.some(
        //       (item) => item.presentation?.status?.toLowerCase() === "active"
        //     );

        //     if (hasActive) {
        //       return {
        //         redirect: "goToOrders",
        //       };
        //     }
        //   }
        // }
        let variables = {};
        if (args?.email) {
          variables = { email: args?.email };
        }
        console.log(variables);
        // let id: any;
        // if (!_token?.accessToken) {
        //   id = await client.query({
        //     query: GetOpenReg,
        //     variables: {},
        //     fetchPolicy: "network-only",
        //   });
        // }
        const res = await client.query(
          // _token?.accessToken
          //   ? {
          //       query: GET_PRESENTATION,
          //       variables: {},
          //       fetchPolicy: "network-only",
          //     }
          //   :
          {
            query: GET_OPEN_PRESENTATION,
            variables: variables,
            fetchPolicy: "network-only",
          }
        );
        if (!_token?.accessToken)
          storageSrv.set(
            "presentationId",
            res?.data?.getOpenRegReferredSections?.myPresentations?.[0]?.id,
            "local"
          );

        const res_data =
          res?.data?.getMyReferedSections?.myPresentations ??
          res?.data?.getOpenRegReferredSections?.myPresentations;
        console.log(res_data, "res_data");
        if (
          res_data &&
          is.existy(res_data) &&
          is.not.empty(res_data) &&
          res_data?.length > 0
        ) {
          let sectionArray: any = [];

          for (let obj of res_data) {
            if (
              is.existy(obj) &&
              is.existy(obj?.status) &&
              is.existy(obj?.year) &&
              obj?.status === "active"
            ) {
              console.log(obj);
              console.log(presentationArray);
              const payload = this.formatData(presentationArray, obj, args);
              console.log(payload);
              if (payload && payload.length > 0) {
                sectionArray.push(...payload);
              }
            }
          }

          if (
            sectionArray.length == 0 &&
            presentationArray.length > 0 &&
            !band?.isMultiplePurchase
          ) {
            return {
              redirect: "goToOrders",
            };
          }
          console.log(
            "res?.data?.getMyReferedSections?.myPresentations",
            sectionArray
          );

          let marketingEmailsSet = sectionArray;
          if (!args?.email) {
            marketingEmailsSet = this.cleanCommitteeEmails(
              sectionArray,
              emailMap
            );
          }
          console.log(
            "res?.data?.getMyReferedSections?.myPresentations",
            marketingEmailsSet
          );
          return {
            sectionArray: marketingEmailsSet,
          };
        } else {
          return [];
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  // private cleanCommitteeEmails(data, emailMap) {
  //   const emailsToRemove = new Set(
  //     Object.values(emailMap).map((entry) => entry?.value?.toLowerCase())
  //   );

  //   return (
  //     data
  //       ?.map((section) => {
  //         const cleanedListItems =
  //           section?.listItems?.filter((item) => {
  //             if (item?.title === "Committee") {
  //               const subtitle = item?.subtitle;

  //               if (Array.isArray(subtitle)) {
  //                 const filtered = subtitle?.filter(
  //                   (entry) => !emailsToRemove.has(entry?.value?.toLowerCase())
  //                 );
  //                 if (filtered?.length === 0) return false; // remove if empty
  //                 item.subtitle = filtered;
  //                 return true;
  //               }

  //               if (typeof subtitle === "string") {
  //                 return (
  //                   subtitle?.trim() !== "" &&
  //                   !emailsToRemove.has(subtitle?.toLowerCase())
  //                 );
  //               }

  //               return false; // remove if null, undefined, or invalid
  //             }

  //             return true; // keep non-Committee items
  //           }) ?? [];

  //         return {
  //           ...section,
  //           listItems: cleanedListItems,
  //         };
  //       })
  //       ?.filter((section) => section?.listItems?.length > 0) ?? []
  //   );
  // }
  private cleanCommitteeEmails(data, emailMap) {
    const marketingEmails = new Set(
      Object.values(emailMap).map((entry) => entry?.value?.toLowerCase())
    );

    return (
      data?.filter((section) => {
        const committeeItem = section?.listItems?.find(
          (item) => item?.title === "Committee" && Array.isArray(item?.subtitle)
        );
        console.log("committeeItem========", committeeItem);
        if (!committeeItem) return true; // no committee → keep section

        const originalSubtitles = committeeItem?.subtitle;
        const subtitleValues = originalSubtitles?.map((s) =>
          s?.value?.toLowerCase()
        );

        const allAreMarketing = subtitleValues.every((email) =>
          marketingEmails.has(email)
        );

        // ❌ Case 1: All emails match marketing → remove whole section
        if (allAreMarketing) return false;

        // ✅ Case 2: Some match, some don't → keep, but filter only matched ones
        committeeItem.subtitle = originalSubtitles.filter(
          (s) => !marketingEmails.has(s?.value?.toLowerCase())
        );

        return true;
      }) ?? []
    );
  }

  private getListItems = (
    presentation: any,
    section: any,
    marketingInfo?: any
  ) => {
    console.log(presentation, presentation?.committeeNames, section);
    let listItems: any = [];
    let index = 0;

    if (presentation?.name && is.existy(presentation?.name)) {
      listItems.push({
        key: index.toString(),
        icon: "https://img.icons8.com/ios-filled/50/f5f5f5/instagram-check-mark.png",
        title: "Presentation Name",
        subtitle: presentation?.name,
      });
      index++;
    }

    if (section?.myCostumeType && is.existy(section?.myCostumeType)) {
      const obj = section?.myCostumeType;
      if (obj && is.not.empty(obj)) {
        listItems.push({
          key: index.toString(),
          icon: "https://img.icons8.com/ios-filled/50/f5f5f5/instagram-check-mark.png",
          title: "",
          subtitle: obj?.name,
        });
        index++;
      }
    }

    let subtitleData: any = [];

    if (marketingInfo?.item) {
      // ✅ Use marketing info if present
      subtitleData = [marketingInfo?.item];
    } else if (
      presentation?.committeeNames &&
      presentation?.committeeNames?.length > 0
    ) {
      // ✅ Use committeeNames if marketingInfo not present
      subtitleData = presentation.committeeNames.map((item: any) => {
        const label =
          item.firstName || item.lastName
            ? [item.firstName, item.lastName].filter(Boolean).join(" ")
            : item.email;

        return {
          label,
          value: item.email,
        };
      });
    }

    if (subtitleData.length > 0) {
      listItems.push({
        key: index.toString(),
        icon: "https://img.icons8.com/ios-filled/50/f5f5f5/instagram-check-mark.png",
        title: "Committee",
        preItem: section?.myCostumeType,
        subtitle: subtitleData,
      });
      index++;
    }

    return listItems;
  };

  private extractImages(data: any, imagesArr: any[]) {
    if (data?.images && is.existy(data?.images) && is.not.empty(data?.images)) {
      for (let obj of data?.images) {
        if (obj && is.existy(obj)) {
          if (isVideo.test(obj)) {
            imagesArr.push({
              type: "video",
              src: obj,
            });
          } else if (isYoutubeVideo.test(obj)) {
            imagesArr.push({
              type: "video",
              src: obj,
            });
          } else {
            imagesArr.push({
              type: "img",
              src: obj,
            });
          }
        }
      }
    }

    return imagesArr;
  }

  private getAllSectionImages = (section: any) => {
    let imagesArr: any = [];

    imagesArr = this.extractImages(section, imagesArr);

    if (
      section?.myCostumeType &&
      is.existy(section?.myCostumeType) &&
      is.not.empty(section?.myCostumeType)
    ) {
      let obj = section?.myCostumeType;
      if (obj && is.existy(obj)) {
        imagesArr = this.extractImages(obj, imagesArr);
      }
    }

    return imagesArr;
  };

  private getDropDownListItems = (section: any, payload: any) => {
    console.log(section, "section");
    let listItems: any = [];
    let partition: string = payload?.referal?.partition;

    if (section?.myCostumeType && is.not.empty(section?.myCostumeType)) {
      let obj = section?.myCostumeType;
      if (obj && is.existy(obj) && is.not.empty(obj) && obj?.isVisible) {
        switch (partition) {
          case "Default":
            obj.isMyCostumeTypeSold = obj?.inventoryDetail?.isDefaultSold;
            break;
          case "SectionSpecific":
            obj.isMyCostumeTypeSold =
              obj?.inventoryDetail?.isSectionSpecificSold;
            break;
          case "SpecialReserve":
            obj.isMyCostumeTypeSold =
              obj?.inventoryDetail?.isSpecialReserveSold;
            break;
        }

        if (obj?.isMyCostumeTypeSold) {
          obj.name = obj.name + " [sold out]";
        }

        listItems.push({
          ...obj,
          section: section?.id,
          refID: payload?.referal?.id,
        });
      }
    }

    if (listItems.length > 0) {
      listItems.unshift({
        name: "Select options",
        id: "",
      });
    }

    return listItems;
  };

  private formatData(presentationArray: any, data: any, args?: any) {
    let appCardList: any = [];

    if (data?.mySections && is.array(data?.mySections)) {
      for (let obj of data?.mySections) {
        console.log(obj);
        if (obj && is.existy(obj) && is.not.empty(obj)) {
          console.log(obj);
          console.log(
            data?.name,
            presentationArray,
            presentationArray.includes(data?.name)
          );
          const regMode = obj?.regMode
            ? String(obj.regMode).trim().toLowerCase().replace(/[\s_]+/g, "")
            : null;
          const isRegModeAllowed =
            regMode === null ||
            regMode === "" ||
            regMode === "open" ||
            regMode === "openandclosed";

          if (
            ((obj?.isVisible && !presentationArray.includes(data?.name)) ||
              (obj?.isVisible && presentationArray.includes(data?.name) && true)) &&
            isRegModeAllowed
            // band?.isMultiplePurchase
          ) {
            appCardList.push({
              heroImage: {
                title: obj?.name,
                alias: obj?.alias,
              },
              title: obj?.name,
              subtitle: obj?.description,
              partition: data?.referal?.partition,
              listItems: this.getListItems(data, obj, args),
              sectionAllImages: this.getAllSectionImages(obj),
              dropDownListItems: this.getDropDownListItems(obj, data),
              inviteType: data?.referal?.inviteType,
              refID: data?.referal?.id,
            });
          }
        }
      }
    }

    return appCardList;
  }
}
